module.exports = __webpack_public_path__ + "img/no-chat.6257ddf9.png";